import React from 'react';
import classnames from 'classnames';
import { Button } from '@abyss/web/ui/Button';
import { Link } from '@abyss/web/ui/Link';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';

import styles from './header.module.css';

const HeaderSkipLink = () => {
  return (
    <a className={styles.skipLink} href="#main-content">
      Skip to main content
    </a>
  );
};

const HeaderTop = () => {
  return (
    <div className={styles.uhcHeaderTop}>
      <div className={classnames(styles.container, styles.containerLg)}>
        <div className="row">
          <div className={classnames(styles.column, styles.column12)}>
            <div
              className={classnames(
                styles.dFlex,
                styles.alignItemsCenter,
                styles.justifyContentBetween
              )}
            >
              <div className={styles.headerDrop}>
                <span
                  className={classnames(
                    styles.dFlex,
                    styles.alignItemsCenter,
                    styles.gap5
                  )}
                >
                  <span className={styles.dropSize}>More UHC sites</span>
                  <svg
                    width="11"
                    height="7"
                    viewBox="0 0 11 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden
                    focusable={false}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.22419 0.425781L5.07979 4.27298L8.9354 0.425781L10.1198 1.61018L5.07979 6.65018L0.0397949 1.61018L1.22419 0.425781Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </div>
              <div className={styles.headerTabs}>
                <div
                  className={classnames(
                    styles.dFlex,
                    styles.alignItemsCenter,
                    styles.gap30
                  )}
                >
                  <img
                    src="/assets/images/uhc-wordmark@2x.png"
                    alt="UnitedHealthcare wordmark"
                    style={{ height: 11, width: 'auto' }}
                  />
                  <nav>
                    <ul className={styles.tabs}>
                      <li className={classnames(styles.tab, styles.active)}>
                        <a className={styles.tabAnchor} href="#link">
                          Medicare
                        </a>
                      </li>
                      <li className={classnames(styles.tab)}>
                        <a className={styles.tabAnchor} href="#link">
                          Individuals &amp; Families
                        </a>
                      </li>
                      <li className={classnames(styles.tab)}>
                        <a className={styles.tabAnchor} href="#link">
                          Medicaid
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <Button
                variant="tertiary"
                className={styles.signInButton}
                style={{ paddingRight: '0' }}
              >
                <span
                  className={classnames(
                    styles.dFlex,
                    styles.alignItemsCenter,
                    styles.gap5,
                    styles.signIn
                  )}
                >
                  <IconSymbol
                    icon="account_circle"
                    variant="outlined"
                    size={20}
                    className={styles.signInIcon}
                  />
                  <span>Sign in</span>
                  <svg
                    width="11"
                    height="7"
                    viewBox="0 0 11 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden
                    focusable={false}
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.22419 0.425781L5.07979 4.27298L8.9354 0.425781L10.1198 1.61018L5.07979 6.65018L0.0397949 1.61018L1.22419 0.425781Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HeaderSearchForm = () => {
  return (
    <form className={styles.searchForm}>
      <input
        type="search"
        aria-label="Search"
        aria-required="true"
        placeholder="Search"
        className={styles.searchInput}
      />
      <button type="button" className={styles.searchFormButton}>
        <img
          className="d-block"
          src="/assets/icons/search-icon@2x.png"
          alt="search icon"
          style={{ height: 24, width: 24 }}
        />
        <span>Search</span>
      </button>
    </form>
  );
};

const HeaderMain = () => {
  return (
    <div className={styles.headerMain}>
      <div className={classnames(styles.container, styles.containerLg)}>
        <div className="row">
          <div className={classnames(styles.column, styles.column12)}>
            <div
              className={classnames(
                styles.dFlex,
                styles.alignItemsCenter,
                styles.justifyContentBetween
              )}
            >
              <div
                className={classnames(
                  styles.dFlex,
                  styles.alignItemsCenter,
                  styles.gap15
                )}
              >
                <a href="#link" className="uhc-header__logo">
                  <img
                    className={styles.mainLogo}
                    src="/assets/images/uhc-logo@2x.png"
                    alt="UnitedHealthcare logo"
                  />
                </a>
              </div>
              <div className={styles.mobile}>
                <ul className={styles.mobileNav}>
                  <li className="position-relative">
                    <span className={styles.mainNavMobileItem}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_8049_113371)">
                          <path
                            d="M14.9992 25.3001C14.7992 25.3001 14.5992 25.2001 14.3992 25.1001L5.09922 16.0001C3.89922 14.8001 3.19922 13.2001 3.19922 11.6001C3.19922 9.90008 3.89922 8.40008 5.09922 7.20008C7.59922 4.80008 11.6992 4.80008 14.1992 7.20008L14.9992 7.90008L15.7992 7.20008C18.1992 4.80008 22.0992 4.80008 24.6992 7.00008L24.8992 7.20008C26.0992 8.40008 26.7992 10.0001 26.7992 11.6001C26.7992 13.3001 26.0992 14.8001 24.8992 16.0001L15.5992 25.1001C15.3992 25.2001 15.1992 25.3001 14.9992 25.3001ZM9.69922 6.80008C8.39922 6.80008 7.19922 7.30008 6.19922 8.20008C5.29922 9.10008 4.79922 10.3001 4.79922 11.6001C4.79922 12.9001 5.29922 14.1001 6.19922 15.0001L14.9992 23.6001L23.7992 15.0001C24.6992 14.1001 25.1992 12.9001 25.1992 11.6001C25.1992 10.4001 24.6992 9.20008 23.8992 8.40008L23.7992 8.30008C21.8992 6.40008 18.6992 6.40008 16.7992 8.30008L15.5992 9.50008C15.2992 9.80008 14.6992 9.80008 14.3992 9.50008L13.1992 8.30008C12.1992 7.30008 10.9992 6.80008 9.69922 6.80008Z"
                            fill="#002677"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8049_113371">
                            <rect width="30" height="30" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Account
                    </span>
                  </li>
                  <li>
                    <span className={styles.mainNavMobileItem}>
                      <img
                        className="d-block"
                        src="/assets/icons/menu-icon@2x.png"
                        alt="menu icon"
                        style={{ height: 30, width: 30 }}
                      />
                      Menu
                    </span>
                  </li>
                </ul>
              </div>
              <div
                className={classnames(
                  styles.desktop,
                  styles.phoneMenu,
                  styles.gap20
                )}
              >
                <Button variant="tertiary" className={styles.phone}>
                  <span
                    className={classnames(
                      styles.dFlex,
                      styles.gap5,
                      styles.alignItemsCenter,
                      styles.phoneContain
                    )}
                  >
                    <img
                      src="/assets/icons/phone-blue-icon@2x.png"
                      alt=""
                      style={{ height: 16, width: 16 }}
                    />
                    <span>1-855-888-1640</span>
                  </span>
                </Button>
                <HeaderSearchForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MenuLinkButton = ({ children, ...rest }) => {
  return (
    <Button variant="tertiary" className={styles.white} {...rest}>
      <span
        className={classnames(
          styles.dFlex,
          styles.alignItemsCenter,
          styles.gap5
        )}
      >
        <span style={{ fontSize: '15px' }}>{children}</span>
        <svg
          width="9"
          height="4"
          viewBox="0 0 9 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
          focusable={false}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.75 0L4.75 4L8.75 0H0.75Z"
            fill="#F9F9F9"
          />
        </svg>
      </span>
    </Button>
  );
};

const HeaderBottom = () => {
  return (
    <div className={classnames(styles.desktop, styles.bottom)}>
      <div className={classnames(styles.container, styles.containerLg)}>
        <div className="row">
          <div className={classnames(styles.column, styles.column12)}>
            <div
              className={classnames(
                styles.dFlex,
                styles.alignItemsCenter,
                styles.justifyContentBetween
              )}
            >
              <Button
                variant="tertiary"
                className={styles.white}
                style={{ fontSize: '15px', paddingLeft: '0' }}
              >
                Medicare
              </Button>
              <div
                className={classnames(styles.dFlex, styles.alignItemsCenter)}
              >
                <nav aria-label="Main menu">
                  <ul
                    className={classnames(
                      styles.dFlex,
                      styles.alignItemsCenter
                    )}
                  >
                    <li>
                      <MenuLinkButton>Shop Medicare Plans</MenuLinkButton>
                    </li>
                    <li>
                      <MenuLinkButton>Learn about Medicare</MenuLinkButton>
                    </li>
                    <li>
                      <MenuLinkButton>Member Resources</MenuLinkButton>
                    </li>
                  </ul>
                </nav>
                <div className="position-relative">
                  <button
                    type="button"
                    className={styles.saved}
                    aria-haspopup="true"
                  >
                    <span
                      className={classnames(
                        styles.dFlex,
                        styles.alignItemsCenter,
                        styles.gap10
                      )}
                    >
                      <svg
                        width="18"
                        height="15"
                        viewBox="0 0 18 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.075 0C11.596 0 10.1765 0.662125 9.25 1.70845C8.3235 0.662125 6.904 0 5.425 0C2.807 0 0.75 1.9782 0.75 4.49591C0.75 7.58583 3.64 10.1035 8.0175 13.9292L9.25 15L10.4825 13.921C14.86 10.1035 17.75 7.58583 17.75 4.49591C17.75 1.9782 15.693 0 13.075 0ZM9.335 12.7112L9.25 12.7929L9.165 12.7112C5.119 9.18801 2.45 6.85831 2.45 4.49591C2.45 2.86104 3.725 1.63488 5.425 1.63488C6.734 1.63488 8.009 2.44414 8.4595 3.56403H10.049C10.491 2.44414 11.766 1.63488 13.075 1.63488C14.775 1.63488 16.05 2.86104 16.05 4.49591C16.05 6.85831 13.381 9.18801 9.335 12.7112Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    <span>Your saved items</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Header = ({ className, ...rest }) => {
  return (
    <header className={styles.uhcHeader} {...rest}>
      <HeaderSkipLink />
      <HeaderTop />
      <HeaderMain />
      <HeaderBottom />
    </header>
  );
};
